const magic = process.lang;

export function loadLanguage(vue, sections = []) {
  return Promise.all(sections.map(async (section) => {
    const langZh = magic[`${section}_zh`];
    if (langZh === undefined) {
      // fetch language file if pre-build language missing
      const respZh = await fetch(`/ics/property/lang/zh/${section}`);
      vue.$i18n.mergeLocaleMessage('zh', {
        [section]: await respZh.json(),
      });
    } else {
      vue.$i18n.mergeLocaleMessage('zh', {
        [section]: langZh,
      });
    }

    const langGb = magic[`${section}_gb`];
    if (langGb === undefined) {
      // fetch language file if pre-build language missing
      const respGb = await fetch(`/ics/property/lang/gb/${section}`);
      vue.$i18n.mergeLocaleMessage('gb', {
        [section]: await respGb.json(),
      });
    } else {
      vue.$i18n.mergeLocaleMessage('gb', {
        [section]: langGb,
      });
    }

    const langEn = magic[`${section}_en`];
    if (langEn === undefined) {
      const respEn = await fetch(`/ics/property/lang/en/${section}`);
      vue.$i18n.mergeLocaleMessage('en', {
        [section]: await respEn.json(),
      });
    } else {
      vue.$i18n.mergeLocaleMessage('en', {
        [section]: langEn,
      });
    }
  }));
}

export default {
  loadLanguage,
};
